import { render, staticRenderFns } from "./tradeHistory.vue?vue&type=template&id=603d0594&scoped=true"
import script from "./tradeHistory.vue?vue&type=script&lang=js"
export * from "./tradeHistory.vue?vue&type=script&lang=js"
import style0 from "./tradeHistory.vue?vue&type=style&index=0&id=603d0594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603d0594",
  null
  
)

export default component.exports